import Vue from 'vue';
import config from '@/config'
import Router from 'vue-router';
import ajax from 'axios'

Vue.use(Router);

// 解决重复点击导航路由报错
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err);
}

const routes = [
    {
        path: '/',
        name: 'home',
        redirect: '/web/login',
    },
    //登录注册组件-web
    {
        path: '/web/login',       //登录
        component: resolve => require(['@/views/page/loginWeb/login.vue'], resolve)
    },{
        path: '/web/gptLogin',       // gpt登录
        component: resolve => require(['@/views/page/loginWeb/gptLogin.vue'], resolve)
    },
    {
        path: '/web/registe',        //注册
        component: resolve => require(['@/views/page/loginWeb/registe.vue'], resolve)
    },
    {
        path: '/web/findpassword',   //找回密码
        component: resolve => require(['@/views/page/loginWeb/findPassword.vue'], resolve)
    },
    {
        path: '/web/bindphone',      //绑定手机号
        component: resolve => require(['@/views/page/loginWeb/bindPhone.vue'], resolve)
    },
    {
        path: '/web/changePassword',  // 修改密码
        component: resolve => require(['@/views/page/loginWeb/changePassword.vue'], resolve)
    },

    //登录注册组件-app
    {
        path: '/app/login',       //登录
        component: resolve => require(['@/views/page/loginApp/login.vue'], resolve)
    },
    {
        path: '/app/registe',        //注册
        component: resolve => require(['@/views/page/loginApp/registe.vue'], resolve)
    },
    {
        path: '/app/findpassword',   //找回密码
        component: resolve => require(['@/views/page/loginApp/findPassword.vue'], resolve)
    },
    {
        path: '/app/resetpassword',   //重置密码
        component: resolve => require(['@/views/page/loginApp/resetPassword.vue'], resolve)
    },
    {
        path: '/app/bindphone',   //绑定手机号
        component: resolve => require(['@/views/page/loginApp/bindPhone.vue'], resolve)
    },
    {
        path: '/app/bindwechat',   //绑定微信
        component: resolve => require(['@/views/page/loginApp/bindWechat.vue'], resolve)
    },
    {
        path: '/app/changephone',   //更改手机号
        component: resolve => require(['@/views/page/loginApp/changePhone.vue'], resolve)
    },
    
    {
        path: '/404',
        component: resolve => require(['@/views/page/404.vue'], resolve)
    },
];

const router = new Router({
    routes: routes
});

router.beforeEach((to, from, next) => {
    const notLoginUrl = [
        "/web/login",
        "/web/gptLogin",
        "/web/registe",
        "/web/findpassword",
        "/web/bindphone",
        "/web/changePassword",
        "/app/login",
        "/app/registe",
        "/app/findpassword",
        "/app/resetpassword",
        "/app/bindphone",
        "/app/bindwechat",
        "/app/changephone"
    ];
    if (notLoginUrl.indexOf(to.path) > -1) {
        next();
        return;
    }
});

export default router;
